import type { WorkspaceUsageItem } from '@/entities/workspace/workspace-types';

export type CampaignAnalysisReportUsage = WorkspaceUsageItem;

export const FALLBACK_CAMPAIGN_ANALYSIS_REPORT_USAGE = {
  used: 0,
  limit: 5,
  remaining: 5,
} satisfies CampaignAnalysisReportUsage;

export const CAMPAIGN_ANALYSIS_REPORT_USAGE_INFO = (max: number) =>
  `You can generate up to ${max} campaign analysis reports per workspace each month. Successful report generation uses 1 count.`;

export const CAMPAIGN_ANALYSIS_REPORT_LIMIT_REACHED =
  'This workspace has reached its monthly campaign analysis report generation limit. The count resets next month.';

export function isCampaignAnalysisReportUsageAtLimit(
  usage: CampaignAnalysisReportUsage | undefined,
) {
  return usage != null && usage.limit > 0 && usage.used >= usage.limit;
}

export function getCampaignAnalysisReportUsageLabel(usage: CampaignAnalysisReportUsage) {
  return `${usage.used} / ${usage.limit} used`;
}
